import { useContext } from 'react'

import SessionContext from '@/context/SessionContext'

export default function useSession() {
  const sessionContext = useContext(SessionContext)

  if (!sessionContext) {
    throw new Error('sessionContext has to be used within <SessionContext.Provider>')
  }

  return sessionContext
}
